// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { markLectureAsComplete } from '../../../services/operations/courseDetailsAPI';
// import { updateCompletedLectures } from '../../../slices/viewCourseSlice';
// import { Player } from 'video-react';
// import { FiPlay } from "react-icons/fi";
// import 'video-react/dist/video-react.css';

// function VideoDetails(props) {
    
//     const {courseId,sectionId,subSectionId} = useParams();
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const playerRef = useRef();
//     const location = useLocation();
//     const {token} = useSelector((state)=>state.auth);
//     const {courseSectionData,courseEntireData,completedLectures} = useSelector((state)=>state.viewCourse);

//     const [videoData,setVideoData] = useState([]);
//     const [videoEnded, setVideoEnded] = useState(false);
//     const [loading,setLoading] = useState(false);


//     useEffect(()=>{
//         async function setVideoSpecificDetails()
//         {
//             if(!courseSectionData)
//             {
//                 return;
//             }
//             if(!courseId && !sectionId && !subSectionId)
//             {
//                 navigate("/dashboard/enrolled-courses");
//             }
//             else
//             {
//                 // course id section id and subsection id has values
                
//                 // section received from the parameters
//                 const filteredData = courseSectionData.filter((course)=> course._id === sectionId);

//                 const filteredVideoData = filteredData?.[0].subSection.filter((data)=> data._id === subSectionId);
//                 console.log("FilteredVideoData: ",filteredVideoData);
//                 setVideoData(filteredVideoData[0]);
//                 setVideoEnded(false);

//             }
//         }
//         setVideoSpecificDetails();
//     },[courseSectionData,courseEntireData,location.pathname])

//     function isFirstVideo()
//     {
//         // we will not show previous video button for the first course
//         const currentSectionIndex = courseSectionData.findIndex((data)=>data._id === sectionId);

//         const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex((data)=>
//             data._id === subSectionId)

//             if(currentSectionIndex === 0 && currentSubSectionIndex === 0)
//             {
//                 return true;
//             }
//             else
//             {
//                 return false;
//             }
//     }

//     function isLastVideo()
//     {
//         // if the video is last we are not going to show next button
//         // we will not show previous video button for the first course
//         const currentSectionIndex = courseSectionData.findIndex((data)=>data._id === sectionId);

//         // finding number of subsection in an section
//         const noOfSubSection = courseSectionData[currentSectionIndex].subSection.length;

//         // finding current subsection index
//         const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex((data)=>
//             data._id === subSectionId)

//         // if currentSection index is n-1 means it is the last section
//         // if currentSubSection index is m-1 it is the last video of that subsection
//         if(currentSectionIndex === courseSectionData.length-1 && currentSubSectionIndex === noOfSubSection - 1)
//         {
//             return true;
//         }
//         else
//         {
//             return false;
//         }
//     }

//     function goToNextVideo()
//     {
//         // if the video is last we are not going to show next button
//         // we will not show previous video button for the first course
//         const currentSectionIndex = courseSectionData.findIndex((data)=>data._id === sectionId);

//         // finding number of subsection in an section
//         const noOfSubSection = courseSectionData[currentSectionIndex].subSection.length;

//         // finding current subsection index
//         const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex((data)=>
//             data._id === subSectionId)

//         if(currentSubSectionIndex !== noOfSubSection - 1)
//         {
//             // subsection has videos
//             const nextSubsectionId = courseSectionData[currentSectionIndex].subSection[currentSubSectionIndex+1]._id;

//             // go to this next video
//             navigate(`/view-course/${courseId}/section/${sectionId}/sub-section/${nextSubsectionId}`)
//         }
//         else
//         {
//             // different section first video
//             const nextSectionId = courseSectionData[currentSectionIndex+1]._id;

//             // subsection id
//             const nextSubSectionId = courseSectionData[currentSectionIndex+1]?.subSection[0]._id;

//             // go to next video
//             navigate(`/view-course/${courseId}/section/${nextSectionId}/sub-section/${nextSubSectionId}`);
//         }
//     }

//     function goToPreviousVideo()
//     {
//         // if the video is last we are not going to show next button
//         // we will not show previous video button for the first course
//         const currentSectionIndex = courseSectionData.findIndex((data)=>data._id === sectionId);

//         // finding number of subsection in an section
//         const noOfSubSection = courseSectionData[currentSectionIndex].subSection.length;

//         // finding current subsection index
//         const currentSubSectionIndex = courseSectionData[currentSectionIndex].subSection.findIndex((data)=>
//             data._id === subSectionId)

//         if(currentSubSectionIndex !== 0)
//         {
//             // video other then 1st video

//             // same section previous video
//             const previousSubSectionId = courseSectionData[currentSectionIndex].subSection[currentSubSectionIndex-1]._id;

//             // go to this next video
//             navigate(`/view-course/${courseId}/section/${sectionId}/sub-section/${previousSubSectionId}`)
//         }
//         else
//         {
//             // different section last video
//             const previousSectionId = courseSectionData[currentSectionIndex-1]._id;

//             // length of previous subsection
//             const previoudSubSectionLength = courseSectionData[currentSectionIndex - 1].subSection.length;

//             // subsection id for previous section
//             const previousSubsectionId = courseSectionData[currentSectionIndex - 1]?.subSection[previoudSubSectionLength-1]._id;

//             // go to next video
//             navigate(`/view-course/${courseId}/section/${previousSectionId}/sub-section/${previousSubsectionId}`);
//         }
//     }

//     async function handleLectureComplete()
//     {
//         setLoading(true);

//         const res = await markLectureAsComplete({courseId:courseId,subSectionId:subSectionId},token);

//         // update state
//         if(res)
//         {
//             dispatch(updateCompletedLectures(subSectionId));
//         }

//         setLoading(false);
//     }

//     return (
//         <div className='text-richblack-100'>
//             {
//                 !videoData ? (<div className='loading'></div>) : (
//                     <Player ref={playerRef} aspectRatio='16:9' playsInline onEnded={()=> setVideoEnded(true)}
//                         src={videoData?.videoUrl}
//                     >
//                         <FiPlay />

//                         {
//                             videoEnded && (
//                                 <div>
//                                     {
//                                         !completedLectures.includes(subSectionId) && (
//                                             <button onClick={()=>handleLectureComplete()}>
//                                                 {!loading ? "Marked as completed" : "Loading"}
//                                             </button>
//                                         )
//                                     }

//                                     <button onClick={()=>{
//                                         if(playerRef?.current)
//                                         {
//                                             playerRef?.current?.seek(0);
//                                             setVideoEnded(false);
//                                         }
//                                     }}>
//                                         Rewatch
//                                     </button>

//                                     <div>
//                                         {
//                                             !isFirstVideo() && (
//                                                 <button className='blackButton' onClick={() => {goToPreviousVideo()}}>
//                                                     Previous
//                                                 </button>
//                                             )
//                                         }
//                                         {
//                                             !isLastVideo() && (
//                                                 <button className='' onClick={()=>{goToNextVideo()}}>
//                                                     Next Video
//                                                 </button>
//                                             )
//                                         }
//                                     </div>

//                                 </div>
//                             )
//                         }

//                     </Player>
//                 )
//             }
//             <span>{videoData?.title}</span>
//             <span>{videoData?.description}</span>
//         </div>
//     );
// }

// export default VideoDetails;

import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import "video-react/dist/video-react.css"
import { useLocation } from "react-router-dom"
import { BigPlayButton, Player } from "video-react"

import { markLectureAsComplete } from "../../../services/operations/courseDetailsAPI"
import { updateCompletedLectures } from "../../../slices/viewCourseSlice"
import IconBtn from "../../core/Dashboard/AddCourse/CourseForm/IconButton"

const VideoDetails = () => {
  const { courseId, sectionId, subSectionId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const playerRef = useRef(null)
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth)
  const { courseSectionData, courseEntireData, completedLectures } =
    useSelector((state) => state.viewCourse)

  const [videoData, setVideoData] = useState([])
  const [previewSource, setPreviewSource] = useState("")
  const [videoEnded, setVideoEnded] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (!courseSectionData.length) return
      if (!courseId && !sectionId && !subSectionId) {
        navigate(`/dashboard/enrolled-courses`)
      } else {
        // console.log("courseSectionData", courseSectionData)
        const filteredData = courseSectionData.filter(
          (course) => course._id === sectionId
        )
        // console.log("filteredData", filteredData)
        const filteredVideoData = filteredData?.[0]?.subSection.filter(
          (data) => data._id === subSectionId
        )
        // console.log("filteredVideoData", filteredVideoData[0])
        setVideoData(filteredVideoData[0])
        setPreviewSource(courseEntireData.thumbnail)
        setVideoEnded(false)
      }
    })()
  }, [courseSectionData, courseEntireData, location.pathname])

  // check if the lecture is the first video of the course
  const isFirstVideo = () => {
    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (currentSectionIndx === 0 && currentSubSectionIndx === 0) {
      return true
    } else {
      return false
    }
  }

  // go to the next video
  const goToNextVideo = () => {
    // console.log(courseSectionData)

    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const noOfSubsections =
      courseSectionData[currentSectionIndx].subSection.length

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    // console.log("no of subsections", noOfSubsections)

    if (currentSubSectionIndx !== noOfSubsections - 1) {
      const nextSubSectionId =
        courseSectionData[currentSectionIndx].subSection[
          currentSubSectionIndx + 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${sectionId}/sub-section/${nextSubSectionId}`
      )
    } else {
      const nextSectionId = courseSectionData[currentSectionIndx + 1]._id
      const nextSubSectionId =
        courseSectionData[currentSectionIndx + 1].subSection[0]._id
      navigate(
        `/view-course/${courseId}/section/${nextSectionId}/sub-section/${nextSubSectionId}`
      )
    }
  }

  // check if the lecture is the last video of the course
  const isLastVideo = () => {
    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const noOfSubsections =
      courseSectionData[currentSectionIndx].subSection.length

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (
      currentSectionIndx === courseSectionData.length - 1 &&
      currentSubSectionIndx === noOfSubsections - 1
    ) {
      return true
    } else {
      return false
    }
  }

  // go to the previous video
  const goToPrevVideo = () => {
    // console.log(courseSectionData)

    const currentSectionIndx = courseSectionData.findIndex(
      (data) => data._id === sectionId
    )

    const currentSubSectionIndx = courseSectionData[
      currentSectionIndx
    ].subSection.findIndex((data) => data._id === subSectionId)

    if (currentSubSectionIndx !== 0) {
      const prevSubSectionId =
        courseSectionData[currentSectionIndx].subSection[
          currentSubSectionIndx - 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${sectionId}/sub-section/${prevSubSectionId}`
      )
    } else {
      const prevSectionId = courseSectionData[currentSectionIndx - 1]._id
      const prevSubSectionLength =
        courseSectionData[currentSectionIndx - 1].subSection.length
      const prevSubSectionId =
        courseSectionData[currentSectionIndx - 1].subSection[
          prevSubSectionLength - 1
        ]._id
      navigate(
        `/view-course/${courseId}/section/${prevSectionId}/sub-section/${prevSubSectionId}`
      )
    }
  }

  const handleLectureCompletion = async () => {
    setLoading(true)
    // console.log("Subsection id: ",subSectionId);
    const res = await markLectureAsComplete(
      { courseID: courseId, subSectionId: subSectionId },
      token
    )
    if (res) {
        dispatch(updateCompletedLectures(subSectionId))
    }
    // console.log("Res: ",res)
    setLoading(false)
  }

  return (
    <div className="flex flex-col gap-5 text-white">
      {!videoData ? (
        <img
          src={previewSource}
          alt="Preview"
          className="h-full w-full rounded-md object-cover"
        />
      ) : (
        <Player
          ref={playerRef}
          aspectRatio="16:9"
          playsInline
          onEnded={() => setVideoEnded(true)}
          src={videoData?.videoUrl}
        >
          <BigPlayButton position="center" />
          {/* Render When Video Ends */}
          {videoEnded && (
            <div
              style={{
                backgroundImage:
                  "linear-gradient(to top, rgb(0, 0, 0), rgba(0,0,0,0.7), rgba(0,0,0,0.5), rgba(0,0,0,0.1)",
              }}
              className="full absolute inset-0 z-[100] grid h-full place-content-center font-inter"
            >
              {!completedLectures.includes(subSectionId) && (
                <IconBtn
                  disabled={loading}
                  onclick={() => handleLectureCompletion()}
                  text={!loading ? "Mark As Completed" : "Loading..."}
                  customClasses="text-xl max-w-max px-4 mx-auto"
                />
              )}
              <IconBtn
                disabled={loading}
                onclick={() => {
                  if (playerRef?.current) {
                    // set the current time of the video to 0
                    playerRef?.current?.seek(0)
                    setVideoEnded(false)
                  }
                }}
                text="Rewatch"
                customClasses="text-xl bg-white max-w-max px-4 mx-auto mt-2"
              />
              <div className="mt-10 flex min-w-[250px] justify-center gap-x-4 text-xl">
                {!isFirstVideo() && (
                  <button
                    disabled={loading}
                    onClick={goToPrevVideo}
                    className="blackButton"
                  >
                    Previous
                  </button>
                )}
                {!isLastVideo() && (
                  <button
                    disabled={loading}
                    onClick={goToNextVideo}
                    className="blackButton text-white"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          )}
        </Player>
      )}

      <h1 className="mt-4 text-3xl font-semibold">{videoData?.title}</h1>
      <p className="pt-2 pb-6">{videoData?.description}</p>
    </div>
  )
}

export default VideoDetails
// video
